import React from 'react';
import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

/**
 * Modal de alerta para notificar al asesor sobre préstamos en mora.
 * Se muestra automáticamente cuando existen préstamos morosos por gestionar.
 */
const ModalAlertaCuotasVencidas = ({ isOpen, onClose, totalPrestamosEnMora, totalCuotasVencidas }) => {
  const navigate = useNavigate();
  const totalRegistrosEnMora = totalPrestamosEnMora ?? totalCuotasVencidas ?? 0;

  if (!isOpen) return null;

  const handleVerCuotasVencidas = () => {
    onClose();
    navigate('/asesor/gestion-moras');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full animate-fade-in">
        {/* Header con ícono de alerta */}
        <div className="bg-gradient-to-r from-red-500 to-orange-500 rounded-t-xl p-6 relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white hover:text-gray-200 transition"
            aria-label="Cerrar modal"
          >
            <FaTimes size={20} />
          </button>
          
          <div className="flex flex-col items-center text-center">
            <div className="bg-white rounded-full p-4 mb-4">
              <FaExclamationTriangle className="text-red-500 text-4xl" />
            </div>
            <h2 className="text-2xl font-bold text-white">
              ¡Atención! Tienes préstamos en mora
            </h2>
          </div>
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="mb-6">
            <p className="text-gray-700 text-center mb-4">
              Tienes <span className="font-bold text-red-600">{totalRegistrosEnMora}</span>{' '}
              {totalRegistrosEnMora === 1 ? 'préstamo en mora' : 'préstamos en mora'}
            </p>
            <p className="text-gray-600 text-center">
              Revisa su estado consolidado y toma las acciones necesarias para gestionar la mora
            </p>
          </div>

          {/* Información adicional */}
          <div className="bg-orange-50 border-l-4 border-orange-500 p-4 mb-6 rounded">
            <p className="text-sm text-orange-800">
              <span className="font-semibold">Importante:</span> Recuerda que la falta de gestión oportuna impacta directamente en tu bono y genera penalizaciones, afectando en tus indicadores.
            </p>
          </div>

          {/* Botones de acción */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={handleVerCuotasVencidas}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg transition transform hover:scale-105 flex items-center justify-center gap-2"
            >
              <FaExclamationTriangle />
              Ver gestión de moras
            </button>
            <button
              onClick={onClose}
              className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 px-6 rounded-lg transition"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAlertaCuotasVencidas;